import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const CV_PATH = "/api/files/4922ca80bbf6409daf1f840adb2dde50.pdf";
export const cvUrl = () => `${process.env.REACT_APP_BACKEND_URL}${CV_PATH}`;

export const fileUrl = (u) => (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
